import getUserInfo from "@plat-components/utils2/_esm5/getUserInfo";
import jumpLogin from "@plat-components/utils2/_esm5/jumpLogin";

export function login() {
  jumpLogin().then(() => location.reload());
}

function ensureLogin(cb: any) {
  return (...args: any) => {
    getUserInfo()
      .then(userinfo => {
        if (!userinfo) {
          login();
          return;
        }
        return cb(...args);
      })
      .catch(() => {
        login();
      });
  };
}

export default ensureLogin;
